/* Thoson cart drawer: "Parents' Top Picks" (snippets/thx-cart-picks.liquid).
   Loaded by sections/thx-cart-layout.liquid, in the footer group.

   The theme re-renders the drawer markup on every cart change, so the
   listeners live on the document and read everything from the row.
   A colour dot or the version select copies that variant into the row's
   add form (input name="id"), and swaps the price, the compare price and
   the photo. Each dot and option carries its own data-variant, data-price,
   data-compare and data-img, written by the snippet. Adding to the cart is
   the theme's own product-form (ajax), untouched. */
(function () {
  function apply(row, src) {
    if (!row || !src || !src.getAttribute('data-variant')) return;
    var id = src.getAttribute('data-variant');
    var input = row.querySelector('input[name="id"]');
    if (input) input.value = id;

    var now = row.querySelector('.thx-pick__now');
    var price = src.getAttribute('data-price');
    if (now && price) now.textContent = price;

    var was = row.querySelector('.thx-pick__was');
    var compare = src.getAttribute('data-compare') || '';
    if (was) {
      was.textContent = compare;
      if (compare) was.removeAttribute('hidden');
      else was.setAttribute('hidden', '');
    }

    var img = row.querySelector('.thx-pick__img');
    var url = src.getAttribute('data-img');
    if (img && url && img.getAttribute('src') !== url) img.setAttribute('src', url);

    var dots = row.querySelectorAll('.thx-pick__dot');
    for (var i = 0; i < dots.length; i++) {
      dots[i].setAttribute('aria-pressed', dots[i].getAttribute('data-variant') === id ? 'true' : 'false');
    }
  }

  document.addEventListener('click', function (event) {
    var dot = event.target && event.target.closest ? event.target.closest('.thx-pick__dot') : null;
    if (!dot) return;
    event.preventDefault();
    apply(dot.closest('.thx-pick'), dot);
  });

  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select || !select.matches || !select.matches('.thx-pick__select')) return;
    apply(select.closest('.thx-pick'), select.options[select.selectedIndex]);
  });
})();
